import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";
import { Button, Flex, useDisclosure } from "@chakra-ui/react";
import { X } from "lucide-react";
import { NewOrderStep, useNewOrderStore } from "../../../stores/order.store";
import StepIndicator from "../../../components/StepIndicator";
import QuitModal from "../../../components/modals/QuitModal";
import { useSimpleToast } from "../../../hooks/toast.hooks";

export const OrdersNewPageHeader = () => {
	const { getStep } = useNewOrderStore();
	const { saveDraft } = useNewOrderStore();
	const { isUpdate } = useNewOrderStore();
	const navigate = useNavigate();
	const toast = useSimpleToast();
	const queryClient = useQueryClient();
	const confirmExitModal = useDisclosure();

	const currentStep = getStep();

	// Determine step statuses
	const step1Status =
		currentStep > NewOrderStep.CHOOSE_AUDIO_RESPONSIBLE
			? "completed"
			: currentStep === NewOrderStep.CHOOSE_AUDIO_RESPONSIBLE
				? "current"
				: "pending";

	const step2Status =
		currentStep > NewOrderStep.CHOOSE_COMMAND_TYPE
			? "completed"
			: currentStep === NewOrderStep.CHOOSE_COMMAND_TYPE
				? "current"
				: "pending";

	const step3Status =
		currentStep === NewOrderStep.CHOOSE_SETUP ||
		currentStep === NewOrderStep.CHOOSE_RENEW_SETUP
			? "current"
			: currentStep > NewOrderStep.CHOOSE_SETUP ||
					currentStep === NewOrderStep.CHOOSE_SHIPPING ||
					currentStep === NewOrderStep.VALIDATION
				? "completed"
				: "pending";

	const step4Status =
		currentStep === NewOrderStep.VALIDATION
			? "current"
			: currentStep > NewOrderStep.VALIDATION
				? "completed"
				: "pending";

	return (
		<Flex
			px={4}
			h="70px"
			minH="70px"
			w="100%"
			bgColor="white"
			borderBottom="solid 1px"
			borderColor="gray.200"
			justifyContent="space-between"
			alignItems="center"
		>
			<Flex>
				<Button variant="ghost" onClick={confirmExitModal.onOpen}>
					<X className="text-gray-500 pr-2! size-6" />
					Quitter
				</Button>

				<QuitModal
					isOpen={confirmExitModal.isOpen}
					onClose={confirmExitModal.onClose}
					onQuit={() => {
						navigate(-1);
					}}
					onQuitAndSave={() => {
						saveDraft();
						navigate(-1);
					}}
				>
					Vous allez quitter sans enregistrer.
				</QuitModal>
			</Flex>

			<StepIndicator
				steps={[
					{
						label: "Informations générales",
						status: step1Status,
					},
					{
						label: "Type de commande",
						status: step2Status,
					},
					{
						label: "Caractéristiques des embouts",
						status: step3Status,
					},
					{
						label: "Validation",
						status: step4Status,
					},
				]}
			/>

			<Flex gap={4}>
				{isUpdate() === true && (
					<Button
						variant="outline"
						onClick={async () => {
							try {
								saveDraft({ log: true });
								toast.success(
									"Brouillon",
									"La commande en cours a été sauvegardée",
								);
								await queryClient.invalidateQueries();
								navigate("/orders");
							} catch (err) {
								toast.error("Brouillon", "Erreur lors de la sauvegarde");
							}
						}}
					>
						Enregistrer les modifications
					</Button>
				)}
				{isUpdate() === false && (
					<Button
						variant="outline"
						onClick={async () => {
							try {
								saveDraft();
								toast.success(
									"Modification",
									"La commande en cours a été sauvegardée",
								);
								await queryClient.invalidateQueries();
								navigate(-1);
							} catch (err) {
								toast.error("Modification", "Erreur lors de la sauvegarde");
							}
						}}
					>
						Enregistrer en brouillon
					</Button>
				)}
			</Flex>
		</Flex>
	);
};
